import { useEffect, useCallback } from 'react';

export interface PublishToPlatformDialogProps {
  open: boolean;
  /** 关闭（点按钮/遮罩/ESC） */
  onClose: () => void;
}

/**
 * PublishToPlatformDialog — 「发布到投放平台」提示弹窗。
 * 投放平台对接暂未开放（服务间凭证未就绪），当前仅提示"暂未支持"。
 */
export function PublishToPlatformDialog({ open, onClose }: PublishToPlatformDialogProps): JSX.Element | null {
  const handleKeyDown = useCallback(
    (e: DocumentEventMap['keydown']) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    if (open) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [open, handleKeyDown]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="glass-card w-full max-w-sm p-6"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Title */}
        <h3 className="text-base font-semibold text-foreground">发布到投放平台</h3>

        {/* 提示：暂未支持 */}
        <p className="mt-4 text-sm text-muted-foreground">暂未支持，敬请期待。</p>

        {/* Buttons */}
        <div className="mt-5 flex justify-end">
          <button
            onClick={onClose}
            className="glow-btn rounded-lg px-4 py-2 text-sm font-medium text-white"
          >
            知道了
          </button>
        </div>
      </div>
    </div>
  );
}
